import React from 'react';
import {Trans} from '@lingui/macro';

export const messages = {
  ipidSingle: <Trans id="travel.faqIpidSingle" />,
  ipidMulti: <Trans id="travel.faqIpidMulti" />,
  ipidYear: <Trans id="travel.faqIpidYear" />,
  gcSingleMulti: <Trans id="travel.faqGcSingleMulti" />,
  gcYear: <Trans id="travel.faqGcYear" />,
}
